import React from 'react'
import { DonateButton } from 'ppp'
import { useProject } from 'shared'

export const DonateButtonLoader = ({ apiUrl, className }: { apiUrl: string; className?: string }): JSX.Element => {
  const project = useProject(apiUrl)
  return <DonateButton className={className} project={project} status={project.status} />
}
